module.exports = __webpack_public_path__ + "img/5-1.17e582ca.svg";